import styled from 'styled-components'
import { pxToRem } from 'styles/functions'

export const SCContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: ${pxToRem(16)};
  padding: ${pxToRem(40)} ${pxToRem(24)};
  text-align: center;
  width: 100%;
`

export const SCIconWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: ${pxToRem(72)};
  height: ${pxToRem(72)};
  border-radius: 50%;
  background-color: ${({ theme }) => theme.card_background_color || '#f5f5f5'};

  svg {
    width: ${pxToRem(40)};
    height: ${pxToRem(40)};
    color: ${({ theme }) => theme.primary_color || '#888'};
  }
`

export const SCTitle = styled.p`
  margin: 0;
  font-size: ${pxToRem(18)};
  font-weight: 600;
  color: ${({ theme }) => theme.text_color || '#222'};
`

export const SCSubtitle = styled.p`
  margin: 0;
  font-size: ${pxToRem(14)};
  color: ${({ theme }) => theme.text_color || '#666'};
  opacity: 0.7;
  max-width: ${pxToRem(280)};
`